import { render, staticRenderFns } from "./allowDragSortTable.vue?vue&type=template&id=4b167100&scoped=true"
import script from "./allowDragSortTable.vue?vue&type=script&lang=js"
export * from "./allowDragSortTable.vue?vue&type=script&lang=js"
import style0 from "./allowDragSortTable.vue?vue&type=style&index=0&id=4b167100&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b167100",
  null
  
)

export default component.exports